<template>
  <header>
    <nav :class="$style.social">
      <div :class="$style.wrap" class="wrap">
        <a href="http://www.imdb.com/name/nm5037653" :class="$style.imdb">
          <svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-miterlimit="1.414" viewBox="0 0 16 16" clip-rule="evenodd" stroke-linejoin="round"><path d="M14.92 0H1.08C.495.04.04.496 0 1.064V14.92A1.14 1.14 0 0 0 1.067 16h13.896A1.151 1.151 0 0 0 16 14.86V1.14C16 .546 15.536.046 14.944 0h-.025zM1.925 5.507h1.27v4.91h-1.27v-4.91zm7.6 4.91c.302 0 .533-.02.682-.05a.818.818 0 0 0 .38-.177c.104-.08.176-.2.217-.348.04-.15.068-.443.068-.88V7.237c0-.465-.018-.778-.05-.935a.846.846 0 0 0-.208-.43c-.113-.13-.28-.22-.497-.28-.213-.054-.57-.086-1.18-.086h-.95v4.91h1.537zm3.426-1.19c0 .235-.013.385-.036.448-.022.063-.126.095-.203.095-.072 0-.127-.032-.15-.09-.027-.06-.04-.2-.04-.416V7.966c0-.222.013-.362.036-.416.022-.054.072-.08.144-.08.077 0 .18.026.207.094.03.063.042.2.042.402v1.26zM9.54 6.393c.05.027.08.072.094.136.02.062.023.207.023.428V8.86c0 .327-.023.526-.063.598-.04.077-.154.113-.335.113V6.348c.135 0 .23.014.28.046zM5.9 5.507l-.294 2.296-.18-1.247c-.055-.403-.105-.75-.154-1.05H3.626v4.91h1.112l.005-3.24.465 3.24H6l.447-3.314v3.314h1.108v-4.91H5.9zm5.402 0v4.91h1.144l.077-.313c.104.126.217.222.344.285.12.058.307.09.452.09.202 0 .374-.05.52-.16a.694.694 0 0 0 .278-.374 2.8 2.8 0 0 0 .06-.656V7.912c0-.294-.01-.488-.023-.58a.695.695 0 0 0-.113-.28.68.68 0 0 0-.285-.22 1.144 1.144 0 0 0-.438-.077c-.146 0-.332.03-.458.085-.122.06-.235.15-.34.267v-1.6H11.3z"/></svg>
        </a>
        <a href="https://twitter.com/RickBlything" :class="$style.twitter">
          <svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-miterlimit="1.414" viewBox="0 0 16 16" clip-rule="evenodd" stroke-linejoin="round"><path fill-rule="nonzero" d="M16 3.038a6.62 6.62 0 0 1-1.885.517 3.299 3.299 0 0 0 1.443-1.816 6.59 6.59 0 0 1-2.085.795 3.273 3.273 0 0 0-2.396-1.036 3.281 3.281 0 0 0-3.197 4.03A9.329 9.329 0 0 1 1.114 2.1 3.243 3.243 0 0 0 .67 3.75c0 1.14.58 2.143 1.46 2.732a3.278 3.278 0 0 1-1.487-.41v.04c0 1.59 1.13 2.918 2.633 3.22a3.336 3.336 0 0 1-1.482.056 3.287 3.287 0 0 0 3.067 2.28 6.592 6.592 0 0 1-4.077 1.404c-.265 0-.526-.015-.783-.045a9.303 9.303 0 0 0 5.032 1.474c6.038 0 9.34-5 9.34-9.338 0-.143-.004-.284-.01-.425a6.67 6.67 0 0 0 1.638-1.7z"/></svg>
        </a>
        <a href="https://soundcloud.com/rickblything" :class="$style.soundcloud">
          <svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-miterlimit="1.414" viewBox="0 0 16 16" clip-rule="evenodd" stroke-linejoin="round"><path fill-rule="nonzero" d="M.773 8.13c-.034 0-.062.03-.067.066L.55 9.633l.156 1.405c.005.038.033.065.067.065.033 0 .06-.027.066-.065l.178-1.405-.18-1.437C.835 8.158.807 8.13.774 8.13m-.594.552c-.032 0-.06.025-.063.062L0 9.634l.117.872c.004.037.03.063.064.063s.06-.027.065-.063l.14-.874-.14-.89c-.005-.036-.03-.06-.064-.06M1.4 7.85c-.04 0-.075.033-.08.078l-.148 1.705.15 1.643a.08.08 0 0 0 .08.078c.04 0 .074-.033.08-.078l.17-1.643-.17-1.705c-.006-.045-.04-.078-.08-.078m.633-.06c-.05 0-.09.04-.094.092l-.14 1.75.14 1.696c.005.052.045.092.095.092s.09-.04.094-.092l.16-1.695-.16-1.752c-.006-.05-.046-.09-.095-.09m.745 3.551zm0-3.334a.109.109 0 0 0-.106-.106c-.058 0-.104.046-.108.107l-.133 1.623.133 1.71c.004.06.05.105.108.105a.11.11 0 0 0 .107-.106l.152-1.71-.15-1.624zm.538-1.138a.122.122 0 0 0-.12.12L3.07 9.634l.125 1.71a.123.123 0 0 0 .12.118.125.125 0 0 0 .122-.12l.14-1.708-.14-2.644a.126.126 0 0 0-.122-.12m.642-.608a.137.137 0 0 0-.135.133l-.117 3.248.117 1.698a.137.137 0 0 0 .135.134c.072 0 .13-.058.135-.133v.002l.132-1.7-.132-3.247a.137.137 0 0 0-.135-.133m.663-.296a.15.15 0 0 0-.147.148l-.11 3.52.11 1.68a.15.15 0 0 0 .148.146c.08 0 .146-.065.15-.147l.123-1.68-.123-3.52a.153.153 0 0 0-.15-.147m.822.029a.163.163 0 0 0-.162-.16.16.16 0 0 0-.16.16l-.102 3.638.1 1.67a.163.163 0 0 0 .326 0l.113-1.67-.113-3.638zm0 5.307zm.502-5.389a.176.176 0 0 0-.175.175l-.093 3.545.093 1.654c.002.096.08.173.175.173a.177.177 0 0 0 .176-.175v.002l.105-1.655L6.12 6.09a.175.175 0 0 0-.175-.175m.67.115a.192.192 0 0 0-.19.19l-.084 3.416.086 1.643a.188.188 0 0 0 .19.186.191.191 0 0 0 .19-.188L6.9 9.635l-.095-3.416a.192.192 0 0 0-.19-.19m.787-.626a.211.211 0 0 0-.112-.034c-.04 0-.078.01-.11.032a.208.208 0 0 0-.093.17v.038L7.01 9.635l.077 1.634v.006a.206.206 0 0 0 .203.194.199.199 0 0 0 .142-.06.199.199 0 0 0 .06-.142l.01-.162.077-1.47-.087-4.065c0-.07-.037-.13-.09-.167m.091 5.867v-.002zm.579-6.252a.216.216 0 0 0-.327.185v.022l-.09 4.41.047.817.043.793a.22.22 0 0 0 .217.215.22.22 0 0 0 .217-.216v.002l.095-1.61-.096-4.433a.22.22 0 0 0-.108-.185m5.962 2.52c-.27 0-.527.055-.76.153a3.475 3.475 0 0 0-4.718-2.929c-.15.06-.188.117-.19.232v6.246c.002.12.095.215.213.226h5.455c1.087 0 1.968-.87 1.968-1.958 0-1.087-.88-1.968-1.968-1.968"/></svg>
        </a>
        <!-- <a href="https://www.linkedin.com/in/rick-blything-7a70b648" :class="$style.linkedin">
          <svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-miterlimit="1.414" viewBox="0 0 16 16" clip-rule="evenodd" stroke-linejoin="round"><path fill-rule="nonzero" d="M13.632 13.635h-2.37V9.922c0-.886-.018-2.025-1.234-2.025-1.235 0-1.424.964-1.424 1.96v3.778h-2.37V6H8.51v1.04h.03c.318-.6 1.092-1.233 2.247-1.233 2.4 0 2.845 1.58 2.845 3.637v4.188zM3.558 4.955a1.376 1.376 0 1 1-.001-2.751 1.376 1.376 0 0 1 .001 2.751zm1.188 8.68H2.37V6h2.376v7.635zM14.816 0H1.18C.528 0 0 .516 0 1.153v13.694C0 15.484.528 16 1.18 16h13.635c.652 0 1.185-.516 1.185-1.153V1.153C16 .516 15.467 0 14.815 0z"/></svg>
        </a> -->
      </div>
    </nav>

    <div :class="$style.heading" class="wrap">
      <h1 v-if="isHome" :class="$style.title"><router-link to="/"><b>Rick Blything</b> <span>Sound design &amp; field recording</span></router-link></h1>
      <p v-else :class="$style.title"><router-link to="/"><b>Rick Blything</b> <span>Sound design &amp; field recording</span></router-link></p>

      <nav :class="$style.nav">
        <router-link to="/about">About</router-link>
        <router-link to="/services">Services</router-link>
        <router-link to="/commercials">Commercials</router-link>
        <router-link to="/blog">Blog</router-link>
        <router-link to="/contact">Contact</router-link>
      </nav>
    </div>

    <div :class="$style.intro" class="wrap" v-if="this.$slots.default">
      <slot></slot>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'site-header',

    computed: {
      isHome() {
        return this.$route.path === '/';
      },
    },
  };
</script>

<style module lang="postcss">
  .social {
    background-color: #222;

    & a {
      display: inline-block;
      width: 1.3rem;
      margin-left: 1.5rem;
      color: #fff;
      text-decoration: none;
    }

    & svg {
      width: auto;
      height: 1.5rem;
    }

    @media (width >= 50em) {
      & a {
        margin-left: 1rem;
      }

      & svg {
        height: 1rem;
      }
    }

    & .imdb svg {
      fill: #f5de50;
    }

    & .twitter svg {
      fill: #1da1f2;
    }

    & .soundcloud svg {
      fill: #ff8800;
    }

    & .linkedin svg {
      fill: #0077b5;
    }
  }

  .wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0.25rem 1rem;
    max-width: 62.5em;
    width: 100%;

    @media (width >= 50em) {
      padding: 0.25rem 4rem;
    }
  }

  .heading {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 62.5em;
    padding: 1.5rem 1rem;
    text-align: center;

    @media (width >= 33em) {
      flex-wrap: nowrap;
      text-align: left;
    }

    @media (width >= 50em) {
      padding: 2rem 4rem;
    }
  }

  .title {
    width: 100%;
    margin-bottom: 1rem;
    font-size: 1rem;
    font-weight: 300;
    line-height: 1.2;

    & a,
    & b {
      color: #000;
    }

    & a {
      text-decoration: none;
      color: #444;
    }

    & b {
      display: block;
      margin-bottom: 0;
      font-size: 1.3rem;
      line-height: 1.15;
    }

    & span {
      display: inline-block;
      font-size: 0.8rem;
      line-height: 1.4;
    }

    @media (width >= 33em) {
      width: auto;
      margin-bottom: 0;
    }
  }

  .intro {
    max-width: 62.5em;
    margin-bottom: 2rem;
    padding: 1rem;

    & > h1 {
      font-size: 3rem;
      line-height: 1.25;
      font-weight: 600;
    }

    @media (width >= 50em) {
      padding: 1rem 4rem;
    }
  }

  .nav {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;

    & a {
      margin: 0.125rem 0.5rem;
      font-size: 0.75rem;
      text-decoration: none;
      color: #999;
      line-height: 1.2;
      border-bottom: 0.07em solid rgba(255,255,255,0);

      &:not(:global(.router-link-active)):hover {
        border-bottom: 0.07em solid #666;
        color: #666;
      }

      &:global(.router-link-active) {
        cursor: default;
        color: #000;
        font-weight: bold;
      }
    }

    @media (width >= 35em) {
      width: auto;
      justify-content: flex-end;

      & a {
        margin-right: 0;
        margin-left: 1rem;
        font-size: 0.875rem;
      }
    }

    @media (width >= 50em) {
      & a {
        margin-left: 1.5rem;
        font-size: 1rem;
      }
    }

    @media (width >= 75em) {
      & a {
        margin-left: 2rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// SiteHeader.vue?c9d6a8c8